import { createClient } from '@supabase/supabase-js'

// Supabase 配置
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://lbqrnokuguunissxqgoj.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxicXJub2t1Z3V1bmlzc3hxZ29qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk5OTU3MzIsImV4cCI6MjA3NTU3MTczMn0._XKKwtsK7xAYMg4c7EJsI8ni8h07TvFmAMqcssoUxHw'

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('缺少 Supabase 环境变量配置')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // 在 localStorage 中持久化 session
    persistSession: true,
    // 自动刷新 token（保持长期登录）
    autoRefreshToken: true,
    // 检测其他标签页的 session 变化
    detectSessionInUrl: true,
    // 存储 key
    storageKey: 'bilibili-monitor-auth',
    // 使用 localStorage 存储（默认）
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})
